<!-- @format -->

<template>
    <v-navigation-drawer
        v-model="show"
        fixed
        hide-overlay
        app
        class="gst-menu">
        <div class="gst-menu__header d-flex mx-4 my-3">
            <v-btn
                icon
                class="float-md-none float-lg-none"
                @click="show = false">
                <BaseIcon
                    class="gst-icon-chevron-left"
                    symbol-id="icons--dropdown_arrow" />
            </v-btn>
            <h4 class="d-flex mx-2 my-2">
                {{ $t('menuTitle') }}
            </h4>
            <div
                class="gst-menu__invisible"
                style="height: 36px; width: 36px"></div>
        </div>
        <v-divider />
        <div class="gst-menu__links-wrapper">
            <div
                class="my-8 ml-6"
                tabindex="0"
                @click="hideMenu"
                @keypress.esc="hideMenu">
                <router-link
                    class="gst-menu__search-link-wrapper d-flex"
                    :to="{ name: 'home', hash: '#search-products' }">
                    <BaseIcon
                        symbol-id="icons--search"
                        class="mr-1" />
                    <h5>{{ $t('linkSearch') }}</h5>
                </router-link>
            </div>
            <v-divider class="mx-4" />
            <div
                class="d-flex my-8 ml-6"
                tabindex="0"
                @click="hideMenu"
                @keypress.esc="hideMenu">
                <router-link :to="{ name: 'home', hash: '#latest-deals' }">
                    <h5>{{ $t('linkLatestDeals') }}</h5>
                </router-link>
            </div>
            <v-divider class="mx-4" />
            <div
                class="d-flex my-8 ml-6"
                tabindex="0"
                @click="hideMenu"
                @keypress.esc="hideMenu">
                <router-link :to="{ name: 'home', hash: '#faq' }">
                    <h5>{{ $t('linkFaq') }}</h5>
                </router-link>
            </div>
        </div>
        <div class="gst-menu__language-selector d-flex justify-center pb-8 px-6">
            <LanguageSelectField
                is-secondary-type
                show-on-top
                :has-short-form="false" />
        </div>
        <div class="gst-menu__footer d-flex">
            <div
                class="d-flex mt-10"
                tabindex="0"
                @click="hideMenu"
                @keypress.esc="hideMenu">
                <a
                    :href="policyUrl"
                    target="_blank">
                    <h5>{{ $t('_common:terms.termsOfUse') }}</h5>
                </a>
            </div>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import LanguageSelectField from '@tenant/app/components/inputs/LanguageSelectField.vue';

export default {
    name: 'MobileMenu',
    components: {
        LanguageSelectField,
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'views.home.theHeader',
    },
    data() {
        return {
            show: true,
        };
    },
    computed: {
        ...mapGetters({
            appCountry: 'appState/getAppCountry',
        }),
        policyUrl() {
            return this.$router.resolve({
                name: 'policy',
                query: {
                    countryCode: this.appCountry,
                },
            }).href;
        },
    },
    watch: {
        show: function (value) {
            if (!value) {
                this.$emit('close');
            }
        },
    },
    methods: {
        hideMenu() {
            this.show = false;
        },
    },
};
</script>
